var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:'radarChart_' + _vm.id,staticStyle:{"display":"inline-flex"}})])}
var staticRenderFns = []

export { render, staticRenderFns }